import ChatLauncher from "../ChatLauncher";

const ChatWidget = ({ open, unread, background_color }: any) => {
  const handleIconClick = () => {
    if (open) {
      window.parent.postMessage({ type: "MAXIMISE_CHAT_WIDGET_CLOSE" }, "*");
    } else {
      window.parent.postMessage({ type: "MAXIMISE_CHAT_WIDGET_OPEN" }, "*");
    }
  };

  return (
    <ChatLauncher
      onClick={handleIconClick}
      isOpen={open}
      unread={unread}
      background_color={background_color}
    />
  );
};

export default ChatWidget;
